import { cn } from '../../lib/cn.ts';

export interface DeltaProps {
  /** Already-formatted delta incl. sign, e.g. "+18%", "−12s". */
  value: string;
  tone?: 'up' | 'down' | 'neutral';
  className?: string;
  'data-testid'?: string;
}

const toneClass: Record<NonNullable<DeltaProps['tone']>, string> = {
  up: 'bg-[var(--color-stone-100)] text-[var(--color-stone-700)]',
  down: 'bg-[var(--color-stone-100)] text-[var(--color-alert)]',
  neutral: 'bg-[var(--color-stone-100)] text-[var(--color-stone-mid)]',
};

/**
 * Delta — a small, calm change indicator. The sign lives in the text so meaning
 * never depends on colour alone.
 */
export function Delta({ value, tone = 'neutral', className, 'data-testid': testId }: DeltaProps) {
  return (
    <span
      data-testid={testId}
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5',
        'font-[var(--font-mono)] text-[11px] font-medium',
        toneClass[tone],
        className,
      )}
    >
      {value}
    </span>
  );
}
